import { render } from "./DrYouThree.vue?vue&type=template&id=5c9bbbcd&scoped=true"
import script from "./DrYouThree.vue?vue&type=script&lang=js"
export * from "./DrYouThree.vue?vue&type=script&lang=js"

import "./DrYouThree.vue?vue&type=style&index=0&id=5c9bbbcd&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9bbbcd"]])

export default __exports__